<template>
  <div class="nominations">
    <table class="table">
      <thead>
        <tr>
          <th class="text-black-50 border-top-0" scope="col">{{nomineeNominator}}</th>
          <th class="text-black-50 border-top-0" scope="col">Category</th>
          <th class="text-black-50 border-top-0" scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <Nomination v-for="nomination in nominations" v-bind:key="nomination.id"
          :id="nomination.id"
          :name="getNomineeNominatorName(type, nomination)"
          :categories="getNominationCategories(nomination._embedded['wp:term'], nomination)"
          :status="nomination.nomination_approve_decline[0] + nomination.id"
          :profile-pic="(nomination.nominationteam[0] === null ? nomination._embedded.author[0].avatar_urls['48'] : 'http://108.128.243.62/wp-content/uploads/2018/10/team-profile.png')"
          :type="type"
          :statuspending="getNominationStatus(nomination.teamnominationworkflow[0], nomination.id)">
        </Nomination>
      </tbody>
    </table>
  </div>
</template>

<script>
import Nomination from '@/components/Nomination'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
export default {
  props: [
    'nominations',
    'type',
    'statuspending'
  ],
  components: {
    Nomination
  },
  computed: {
    nomineeNominator: function () {
      if (this.type === 'sent') {
        return 'Nominee'
      } else {
        return 'Nominator'
      }
    }
  },
  methods: {
    getNomineeNominatorName: function (type, nomination) {
      var nomineeName = ''
      var nomineeSlug = ''
      if (nomination.nominationteam[0])
      if (nomination.nominationteam[0].length > 0) {
        nomineeName += nomination.nominationteam[0].map(function(name, index){
          return name.member_name
        })
        nomineeSlug +=  nomination.nominationteam[0].map(function(name, index){
          return name.member_slug
        })
      }
      if (type === 'sent') {
        return {name: (nomineeName === '') ? nomination.nominee_name[0] : nomineeName, slug: (nomineeSlug === '') ? nomination.nominee_slug[0] : nomineeSlug}
      } else {
        return {name: nomination._embedded.author[0].name, slug: nomination._embedded.author[0].slug}
      }
    },
    getNominationStatus:function(teamnominationworkflow,id) {
      let workflowStages = ['sponsor', 'manager', 'exco2', 'hrbp']
      let workflowStagesLabel = ['Project Sponsor', 'Line Manager', 'Exco2', 'HCBP']
      var data = []
      var queryString = ''
      var nextStageTemp = -1 

      for (var t = 0; t < teamnominationworkflow.length; t++) {
        var tempnextStage = workflowStages.indexOf(teamnominationworkflow[t].project_sponsor_name.toLowerCase())
        var nextStageTemp = workflowStages.indexOf(teamnominationworkflow[t].project_sponsor_name.toLowerCase())
        if (teamnominationworkflow[t].project_sponsor_status === 'Reject') {
          teamnominationworkflow[t].project_sponsor_status = 'Rejected'
        } else if (teamnominationworkflow[t].project_sponsor_status === 'Approve') {
          teamnominationworkflow[t].project_sponsor_status = 'Approved'
        }
        if (teamnominationworkflow[t].project_sponsor_status === 'Rejected') {
          data =  'Rejected by ' + workflowStagesLabel[nextStageTemp] 
          return data
        } else {
          data = [ '#', teamnominationworkflow[t].project_sponsor_status ]
        }
        if (teamnominationworkflow[t].project_sponsor_status === '') {
            var nextStageTemp = workflowStages.indexOf(teamnominationworkflow[t].project_sponsor_name.toLowerCase())
            data =  'Pending with ' + workflowStagesLabel[nextStageTemp] 
            return data
          } else if(t!==(teamnominationworkflow.length-1)){
            continue
          }
          else if(t===(teamnominationworkflow.length-1)){
            data =  teamnominationworkflow[0].project_sponsor_status 
            return data
          }
      }
    },
    getNominationStatus_old:function(teamnominationworkflow,id) {
      let workflowStages = WordpressRestURI.workflowStages
      let workflowStagesLabel = WordpressRestURI.workflowStagesLabel
      var data = []
      var queryString = ''
      var nextStageTemp = -1 

      for (var t = 0; t < workflowStages.length; t++) {
        let temp = teamnominationworkflow.filter(d => d.project_sponsor_name.toLowerCase() === workflowStages[t])
        if (temp.length > 0) {
          if (temp[0].project_sponsor_status === 'Reject') {
            data =  'Rejection Received by ' + workflowStagesLabel[t]
          } else if (temp[0].project_sponsor_status === '') {
            data =  'Pending from ' + workflowStagesLabel[t]
          } else {
            data =  temp[0].project_sponsor_status 
          }
          break
        }
      }
      return data
  },


    getNominationCategories: function (categoryTerms, nomination) {
      let nomCat = []
      for (var i = 0; i < categoryTerms.length; i++) {
        if (categoryTerms[i].length > 0) {
          if (categoryTerms[i][0].taxonomy === 'nomination_event_category') {
            for (var j = 0; j < categoryTerms[i].length; j++) {
              if (categoryTerms[i][j].id !== 20) {
				nomCat.push({id: categoryTerms[i][j].id, name: categoryTerms[i][j].name})
			  }
            }
          }
        }
      }
      return nomCat
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Nominations.vue